<nz-segmented
  [nzOptions]="enhancedOptions.length ? enhancedOptions : options"
  (nzValueChange)="handleValueChange($event)"
  [(ngModel)]="value"
  [ngClass]="{
    'large': size === 'large',
    'selected-bold': selectedBold,
    'transparent-styles': transparentStyles,
  }"
  data-cy="segmented-switch"
></nz-segmented>